import SkypeToast from './SkypeToast';
import WarningToast from './WarningToast';
import NotificationToastProps from '../store/schema/NotificationToastProps';
import { NotificationActionType } from '../store/schema/NotificationViewState';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

const NotificationToast = observer(function NotificationToast(props: NotificationToastProps) {
    let { notification } = props;
    switch (notification.actionType) {
        case NotificationActionType.SkypeNotification:
        case NotificationActionType.SkypeForBusinessNotification:
            return <SkypeToast notification={notification} />;
        default:
            return <WarningToast notification={notification} />;
    }
});
export default NotificationToast;
